import { GeneralError } from "./GeneralError";

export class InFileError extends GeneralError {
    lineNumber = 0;
    columnNumber = 0;
}
